import React, { useEffect } from "react";
import './colorblocks.css';
import { useDispatch, useSelector } from "react-redux";
import Tooltip from "../Tooltip/Tooltip";
import { getColors } from "../../appState/slices/color/colorSlice";

const ColorBlocks = ({ name,selected,withname }) => {
    const colors = useSelector((state) => state.color.colors);    
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getColors())
    },[])
    return (
        <div className="blockcontainer">
            {withname ?
                <div className={`colorpill ${selected? "productcolorselected" : ""}`}>
                    <div className={`colorcirclebig ${selected? "productcolorcircleselected" : ""}`} style={{ backgroundColor: colors?.colors[name]?.colorCode }}></div> {/* Removed template literals */}
                    {name}
                </div>
                :
                <div className="colorpillwithoutname">
                    <Tooltip text={name}>
                        <div className={`colorcircle`} style={{ backgroundColor: colors?.colors?.[name]?.colorCode }}></div> {/* Removed template literals */}
                    </Tooltip>
                </div>
            }
        </div>
    );
};

export default ColorBlocks;
